import Client from '../client';
import { AxiosRequestConfig } from 'axios';

const BaseService = 
{
    conectarEndpoint(fileRequest: any, endpoint: string, nomeArquivo: string)
    {
        const formData = new FormData();
        formData.append(nomeArquivo, fileRequest);
        const config = { headers: { 'content-type': 'multipart/form-data' } } as AxiosRequestConfig;

        return Client.post(endpoint, formData, config);
    }
}

export default BaseService;